import React, { useEffect, useState, useCallback } from "react";
import style from "./plague.module.css";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import logger from "../../../../utils/logger";
import { isBracellEnterprise } from "../../config/bracellRegistryProfile";
import { BRACELL_REGISTER_PLAGUE_NAMES } from "../../utils/constants";

const PLAGUE_MASTER = [
  { name: "Besouro Amarelo", scientific: "Costalimaita Ferruginea" },
  { name: "Besouro Azul", scientific: "Sternocolaspis Quatuord" },
  { name: "Dyrphia", scientific: "Dyrphia Rosacordis" },
  { name: "Glena", scientific: "Glena Bipennaria" },
  { name: "Hylesia", scientific: "Hylesia Sp" },
  { name: "Lagarta Cachorrinho", scientific: "Eupseudosoma Spp" },
  { name: "Lagarta Marrom", scientific: "Oxydia Vesulia" },
  { name: "Lagarta Parda", scientific: "Thyrinteina Arnobia" },
  { name: "Lagarta Verde", scientific: "Psorocampa Denticulata" },
  { name: "Nistalea", scientific: "Nystalea Nyseus" },
  { name: "Percevejo Bronzeado", scientific: "Thaumastocoris Peregrinus" },
  { name: "Psilideo de Concha", scientific: "Glycaspis Brimblecombei" },
  { name: "Sabulodes", scientific: "Sabulodes Caberata" },
  { name: "Sarsina", scientific: "Sarsina Spp" },
  { name: "Vespa-da-galha", scientific: "Leptocybe Invasa" },
];

function Plague({ plagueSelect, validator }) {
  const [plague, setPlague] = useState("");

  const plague_names = isBracellEnterprise()
    ? PLAGUE_MASTER.filter((p) =>
        BRACELL_REGISTER_PLAGUE_NAMES.includes(p.name)
      )
    : PLAGUE_MASTER.filter((p) => p.name !== "Vespa-da-galha");

  const handleClickSelectPlague = useCallback(() => {
    if (plague !== "" && plague) {
      try {
        JSON.parse(plague);
        plagueSelect(plague);
      } catch (error) {
        logger.warn("Valor de praga inválido:", plague);
      }
    }
  }, [plague, plagueSelect]);

  useEffect(() => {
    if (plague && plague !== "") {
      handleClickSelectPlague();
    }
  }, [plague, handleClickSelectPlague]);

  useEffect(() => {
    if (validator !== undefined) {
      setPlague("");
    }
  }, [validator]);

  return (
    <div className={style["card"]}>
      <div className={style["sector-inputs"]}>
        <FormControl variant="standard" sx={{ minWidth: "100%" }}>
          <InputLabel id="demo-simple-select-standard-label">
            {"Praga"}
          </InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={plague}
            onChange={(value) => setPlague(value.target.value)}
            label="Age"
          >
            {plague_names.map((item, index) => (
              <MenuItem key={index} value={JSON.stringify(item)}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
}

export default Plague;
